import { styled } from '@mui/material';
import React from 'react';
import { Legend as LegendModel } from '../../models';

const LegendContainer = styled('div')`
  ul {
    list-style-type: none;
    display: flex;
    margin: 0;
    padding: 0;
    text-align: center;
  }

  span {
    display: inline-block;
    vertical-align: sub;
  }
`;

type Props = {
  className?: string;
  legendItems: LegendModel[];
}

function Legend({ className, legendItems }: Props) {
  return (
    <LegendContainer className={className}>
      <ul>
        {legendItems.map((item) => (
          <li key={`${item.label}_${item.color}`}>
            <span style={{ backgroundColor: item.color }} />
            <div>{item.label}</div>
          </li>
        ))}
      </ul>
    </LegendContainer>

  );
}

Legend.defaultProps = {
  className: '',
};

export default Legend;
